import type { Reducer } from 'redux';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import * as WorkOrderUtil from 'af-utils/workOrder.util';

import * as ActionTypes from 'af-constants/actionTypes';

import type { WorkOrderStoreState } from 'af-models/workOrder.models';

import type { WorkOrderAction } from 'af-actions/workOrder';

const initialState: WorkOrderStoreState = {
	workOrders: {
		selectedDate: TimeUtils.dateToMomentUtc(new Date())!,
		filterByText: '',
		participantsEmailAndSmsStatuses: {},
	},
	order: null,
	orderAttachments: [],
	confirmationDataAttachments: {},
	copyWorkOrderModalData: null,
};

const WorkOrderReducer: Reducer<WorkOrderStoreState, WorkOrderAction> = (state: WorkOrderStoreState = initialState, action: WorkOrderAction) => {
	switch (action.type) {
		case ActionTypes.LOCK_WORK_ORDER:
			return WorkOrderUtil.setWorkOrderLock(state, action.payload.workOrderId, true);
		case ActionTypes.UNLOCK_WORK_ORDER:
			return WorkOrderUtil.setWorkOrderLock(state, action.payload.workOrderId, false);
				case ActionTypes.DELETE_WORK_ORDER:
			return { ...state };
		case ActionTypes.FIND_WORK_ORDER:
			return { ...state, order: action.payload };
		case ActionTypes.GET_WORK_ORDER_CONFIRMATION_DATA:
			return { ...state, confirmationData: action.payload };
		case ActionTypes.CLEAR_WORK_ORDER_PARTICIPANTS_EMAIL_STATUS:
			return { ...state, participantsEmailAndSmsStatus: null };
		case ActionTypes.CLEAR_WORK_ORDER_LIST:
			return { ...state };
		case ActionTypes.RESET_WORK_ORDER:
			return { ...state, order: initialState.order, orderAttachments: initialState.orderAttachments };
		case ActionTypes.SET_COPY_WORK_ORDER_MODAL_DATA:
			return { ...state, copyWorkOrderModalData: action.payload };
		default:
			return state;
	}
};

export default WorkOrderReducer;
